import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network-wire-edm/HeroSection';
import { BreadcrumbSection } from './edm-network-wire-edm/BreadcrumbSection';
import { DescriptionSection } from './edm-network-wire-edm/DescriptionSection';
import { GSeriesSection } from './edm-network-wire-edm/GSeriesSection';
import { GLXSeriesSection } from './edm-network-wire-edm/GLXSeriesSection';
import { UASeriesSection } from './edm-network-wire-edm/UASeriesSection';
import { RVSeriesSection } from './edm-network-wire-edm/RVSeriesSection';
export function EDMNetworkWireEDMPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2189">
      <SeoBar data-id="element-2190" />
      <Header data-id="element-2191" />
      <main className="flex-grow" data-id="element-2192">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2193">
          <HeroSection data-id="element-2194" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2195">
            <BreadcrumbSection data-id="element-2196" />
            <DescriptionSection data-id="element-2197" />
            <div className="space-y-16" data-id="element-2198">
              <GSeriesSection data-id="element-2199" />
              <GLXSeriesSection data-id="element-2200" />
              <UASeriesSection data-id="element-2201" />
              <RVSeriesSection data-id="element-2202" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-2203" />
    </div>;
}